<template>
  <div class="p-side-drawer-wrapper" :class="classListWrapper">
    <aside :class="classList">
      <div v-if="hasHeader" class="drawer-header">
        <slot name="drawer-header">
          <p-list-entry tag="div">
            <template v-if="hasHeaderImage" #icon-left>
              <slot name="drawer-header-image"></slot>
            </template>
            <template v-if="hasHeaderTitle" #title>
              <slot name="drawer-header-title"></slot>
            </template>
            <template v-if="hasHeaderSubtitle" #subtitle>
              <slot name="drawer-header-subtitle"></slot>
            </template>
          </p-list-entry>
        </slot>
        <p-divider class="my-2 mx-3"></p-divider>
      </div>
      <div class="drawer-content">
        <slot name="drawer-content"></slot>
        <!-- @depreacted - use the named slot instead -->
        <slot></slot>
      </div>
      <div v-if="hasFooter" class="drawer-footer">
        <p-divider class="my-1 mx-3"></p-divider>
        <slot name="drawer-footer">
          <p-row class="drawer-footer-row" align-end :justify-center="minified">
            <p-col grow>
              <p-row no-gutters dense :justify-center="minified">
                <slot name="drawer-footer-actions"></slot>
              </p-row>
            </p-col>
            <p-col shrink :justify-center="minified">
              <p-button
                v-if="isMinifiable"
                tertiary
                class="p-side-drawer-toggle-minified"
                color="surface-2"
                @click="toggleMinified"
              >
                <p-icon>
                  {{ chevronIcon }}
                </p-icon>
              </p-button>
            </p-col>
          </p-row>
        </slot>
      </div>
    </aside>

    <p-overlay v-model="overlayBackgroundVisible" @click.native="toggleVisbility"></p-overlay>

    <div v-if="_.component.hasSlot(this, 'content')" class="p-side-drawer-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import _ from '../../utils';

  export default Vue.extend({
    props: {
      value: { default: true, type: Boolean },
      overlay: { default: false, type: Boolean },
      blur: { default: false, type: Boolean },
      color: { default: 'surface-1', type: String },
      elevation: { default: 1, type: [String, Number] },
      flat: { default: false, type: Boolean },
      minifiable: { default: false, type: Boolean },
      minified: { default: false, type: Boolean },
      right: { default: false, type: Boolean },
      bottom: { default: false, type: Boolean },
      top: { default: false, type: Boolean },
    },
    data: () => ({
      internalVisible: false,
      innerMinifed: false,
    }),
    computed: {
      hasFooter(): boolean {
        return _.component.hasSlot(this, 'drawer-footer-actions')
          || _.component.hasSlot(this, 'drawer-footer')
          || this.isMinifiable;
      },
      isMinifiable(): boolean {
        return this.minifiable && !this.top && !this.bottom;
      },
      chevronIcon() {
        if (this.right) {
          return 'chevron_right';
        }
        if (this.top) {
          return 'expand_less';
        }
        if (this.bottom) {
          return 'expand_more';
        }
        return 'chevron_left';
      },
      hasHeader(): boolean {
        return this.hasHeaderSubtitle || this.hasHeaderImage || this.hasHeaderTitle || this.hasCustomHeader;
      },
      hasHeaderSubtitle(): boolean {
        return this._.component.hasSlot(this, 'drawer-header-subtitle');
      },
      hasHeaderTitle(): boolean {
        return this._.component.hasSlot(this, 'drawer-header-title');
      },
      hasHeaderImage(): boolean {
        return this._.component.hasSlot(this, 'drawer-header-image');
      },
      hasCustomHeader(): boolean {
        return this._.component.hasSlot(this, 'drawer-header');
      },
      hasMinifiableHeader(): boolean {
        if (this.hasCustomHeader) {
          return false;
        }
        return this.hasHeaderImage;
      },
      overlayBackgroundVisible(): boolean {
        return this.overlay && this.internalVisible;
      },
      classListWrapper(): Record<string, boolean> {
        return {
          left: !this.right && !this.top && !this.bottom,
          right: this.right,
          top: this.top,
          bottom: this.bottom,
        };
      },
      classList(): Record<string, boolean> {
        return {
          'p-side-drawer': true,
          [`color-${this.color}`]: true,
          [`elevation-${this.elevation}`]: !this.flat,
          minified: this.minified,
          visible: this.internalVisible,
          overlay: this.overlay,
          'minifiable-header': this.hasMinifiableHeader,
          blur: this.blur,
        };
      },
    },
    watch: {
      value: {
        handler(newValue) {
          this.internalVisible = newValue;
          if (this.$el) {
            // Only store if the side-drawer has been mounted
            // this.setStoredState('visible', this.internalVisible);
          }
        },
        immediate: true,
      },
      minifed: {
        immediate: true,
        handler() {
          this.innerMinifed = this.minified;
        },
      },
    },
    beforeMount() {
      // const isMinifed = this.getStoredState<boolean>('minifed');
      // this.setMinified(isMinifed ?? this.minified);
      // const isVisible = this.getStoredState<boolean>('visible');
      // this.setVisibility(isVisible ?? this.internalVisible);
    },
    methods: {
      toggleMinifed() {
        this.setMinified(!this.innerMinifed);
      },
      setMinified(isMinified: boolean) {
        this.innerMinifed = isMinified;
        // this.setStoredState('minifed', isMinified);
        this.$emit('update:minified', isMinified);
      },
      getStoreName(name: string) {
        const uiPathId = _.component.getComponentUILocationId(this);
        return `SideDrawer_${name}_${uiPathId}`;
      },
      // getStoredState<T = any>(name: string) {
      //   return this.$localStorage.get<T>(this.getStoreName(name));
      // },
      // setStoredState(name: string, value: any) {
      //   this.$localStorage.set(this.getStoreName(name), value);
      // },
      toggleMinified() {
        this.setMinified(!this.minified);
      },
      setVisibility(isVisible: boolean) {
        this.internalVisible = isVisible;
        this.$emit('input', this.internalVisible);
      },
      toggleVisbility() {
        this.setVisibility(!this.internalVisible);
      },
    },
  });
</script>
